module.exports = __webpack_public_path__ + "static/media/Tall.a5b8f719.jpg";